var _rect, _circle, _path, _text, _text2, _line, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 80,
    viewBox: "0 0 220 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8,
    height: 80,
    fill: "#00A3AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 24,
    fill: "#00A3AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 34h16v3H36zm0 6h14v3H36zm0 6h12v3H36z",
    fill: "white",
    opacity: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 36,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    fill: "#00A3AD",
    letterSpacing: 2
  }, "CLINTON HEALTH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 50,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    fill: "#00A3AD",
    letterSpacing: 2
  }, "ACCESS INITIATIVE")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 58,
    x2: 196,
    y2: 58,
    stroke: "#00A3AD",
    strokeWidth: 1,
    opacity: 0.3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 70,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 600,
    fontSize: 10,
    fill: "#00A3AD",
    letterSpacing: 1.5
  }, "CHAI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaiLogo);
export default __webpack_public_path__ + "static/media/chai-logo.7355c75c07c761d589c9b5351fcf1e92.svg";
export { ForwardRef as ReactComponent };